import { useEffect } from "react";
import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import NeedHelp from "../components/Accounts/NeedHelp";
import Banner from "../components/Indices/Banner";
import Cards from "../components/Indices/Cards";

function Indices() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <Cards />
            <WhyArvest />
            <ArvestOffers />
            <NeedHelp />
        </div>
    );
}

export default Indices;
